import { ColoursObj, Icon } from '@eventr/common-storybook'
import { useObjectContext } from '../providers/objectProvider'

interface IVisibilityIconProps {
    visibility: string
}

export const VisibilityIcon = ({ visibility }: IVisibilityIconProps) => {
    const { past } = useObjectContext()
    return (
        <>
            {visibility === 'Private' ? (
                <Icon
                    height={'16px'}
                    width={'16px'}
                    name={'Private'}
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                ></Icon>
            ) : (
                visibility === 'Public' && (
                    <Icon
                        height={'16px'}
                        width={'16px'}
                        name={'Public'}
                        iconColour={
                            past
                                ? ColoursObj.shades.shade2
                                : ColoursObj.core.secondary
                        }
                    ></Icon>
                )
            )}
        </>
    )
}
